export enum SourceTypes {
  SQLAccount = 'SQLAccount',
  AutoCountDesktop = 'AutoCountDesktop',
  Autocount = 'Autocount',
  UBS = 'UBS',
  Xero = 'Xero',
  QuickBooksDesktop = 'QuickBooksDesktop',
  QuickBooksOnline = 'QuickBooksOnline',
  MYOB = 'MYOB',
}

export interface IImportSource {
  label: string;
  value: SourceTypes;
}

export interface ILabelValuePair {
  value: string;
  label: string;
}
